import FullFeatureTable from './FeatureTable';
import {
  fossaPlanMap,
  PREMIUM_COMPLIANCE_PLAN_NAME,
  PREMIUM_COMP_SEC_PLAN_NAME,
} from '../../../../../shared/subscriptions';

const FeatureComparisonHeader = () => (
  <div className="feature-comparison-header">
    <span className="header-title">Feature Comparison</span>
    <span>
      <span className="header-plan">Free</span>
    </span>
    <span>
      <div className="header-plan">Business</div>
      <div>
        <span className="header-price">{`$${fossaPlanMap[PREMIUM_COMPLIANCE_PLAN_NAME].price}`}</span>
        <span className="header-price-suffix">
          /dev/month
        </span>
      </div>
      <div>
        <span className="header-price">{`$${fossaPlanMap[PREMIUM_COMP_SEC_PLAN_NAME].price}`}</span>
        <span className="header-price-suffix">
          /dev/month with Security
        </span>
      </div>
    </span>
    <span>
      <div className="header-plan">Enterprise</div>
      <div>Custom Pricing</div>
    </span>
  </div>
);

const FeatureComparison = () => (
  <>
    <FeatureComparisonHeader />
    <FullFeatureTable />
  </>
);

export default FeatureComparison;
